export default "__VITE_ASSET__DksXR2Zr__"